import { render, staticRenderFns } from "./POISnapshot.vue?vue&type=template&id=4c80fcfc&scoped=true"
import script from "./POISnapshot.vue?vue&type=script&lang=js"
export * from "./POISnapshot.vue?vue&type=script&lang=js"
import style0 from "./POISnapshot.vue?vue&type=style&index=0&id=4c80fcfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80fcfc",
  null
  
)

export default component.exports